import React from "react";
import { highlight } from "../services";

function Function(props) {
  const selected = (id) => {
    if (id > 0) {
      document.getElementById("lgmaincat0").classList.remove("lgselected2");
    }
  };

  return (
    <div className="function">
      <button
        className={`btn ${props.id === 0 ? "lgselected2" : ""} lgmaincat`}
        id={`lgmaincat${props.id}`}
        onClick={() => {
          highlight(props.id);
          selected(props.id);
          props.describe(props.value.description);
        }}
      >
        {props.value.title}
      </button>
    </div>
  );
}
export default Function;
